import { color } from "framer-motion";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
export default function Header() {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showDot, setShowDot] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const onResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setSidebarOpen(false);
    };

    onResize();
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setShowDot((prev) => !prev);
    }, 600);
    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <header style={styles.wrapper}>
        <div
          style={{
            ...styles.navbar,
            width: isMobile ? "92%" : "calc(100% - 32px)",
            maxWidth: isMobile ? "24rem" : "39rem", // Slightly wider for mobile to fit button + hamburger
            height: "3rem",
          }}
        >
          <div
            style={{
              ...styles.container,
              padding: isMobile ? "0 0.6rem" : "0 1rem",
            }}
          >
            {/* Logo Section */}
            <div
              style={{ ...styles.logo, cursor: "pointer" }}
              onClick={() => navigate("/")}
            >
              <img
                src={
                  showDot
                    ? "./images/black red dot.png"
                    : "./images/no red dot.png"
                }
                alt="Rushcut blinking logo"
                style={{
                  width: isMobile ? "6.8rem" : "8.2rem",
                  height: "auto",
                  transition: "opacity 0.15s ease-in-out",
                }}
              />
            </div>

            {/* Desktop Navigation */}
            {!isMobile && (
              <nav style={styles.nav}>
                {/* <NavItem text="Product" onClick={() => navigate("/product")} /> */}
                {/* <NavItem text="Careers" onClick={() => navigate("/")} /> */}
                <NavItem text="Enterprise" onClick={() => navigate("/lets-talk")} />
              </nav>
            )}

            {/* Actions Section (Button + Hamburger) */}
            <div style={styles.actions}>
              <button style={isMobile ? styles.signupMobile : styles.signup} onClick={() => navigate("/lets-talk")}>
                Explore More
              </button>

              {isMobile && (
                <button
                  style={styles.hamburger}
                  onClick={() => setSidebarOpen(true)}
                >
                  ☰
                </button>
              )}
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Sidebar */}
      {isMobile && sidebarOpen && (
        <>
          <div style={styles.overlay} onClick={() => setSidebarOpen(false)} />
          <aside style={styles.sidebar}>
            <button style={styles.close} onClick={() => setSidebarOpen(false)}>✕</button>
            {/* <SidebarItem text="Product" onClick={() => { navigate("/product"); setSidebarOpen(false); }} /> */}
            {/* <SidebarItem text="Careers" onClick={() => { navigate("/"); setSidebarOpen(false); }} /> */}
            <SidebarItem text="Enterprise" onClick={() => { navigate("/lets-talk"); setSidebarOpen(false); }} />
          </aside>
        </>
      )}
    </>
  );
}

function NavItem({ text, dropdown, onClick }) {
  return (
    <div style={styles.navItem} onClick={onClick}>
      {text}
      {dropdown && <span style={styles.chevron}>▾</span>}
    </div>
  );
}

function SidebarItem({ text, onClick }) {
  return (
    <div style={styles.sidebarItem} onClick={onClick}>
      {text}
    </div>
  );
}

/* ---------- STYLES ---------- */

const styles = {
  wrapper: {
    position: "fixed",
    top: "1rem",
    left: 0,
    right: 0,
    zIndex: 1000,
    display: "flex",
    justifyContent: "center",
    pointerEvents: "none",
    fontFamily: "DelightMed",
  },

  navbar: {
    background: "rgba(255, 255, 255, 0.65)",
    backdropFilter: "blur(14px) saturate(180%)",
    WebkitBackdropFilter: "blur(14px) saturate(180%)",
    border: "1px solid rgba(255, 255, 255, 0.35)",
    borderRadius: "14px",
    boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
    pointerEvents: "auto",
  },

  container: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },

  logo: {
    display: "flex",
    alignItems: "center",
  },

  nav: {
    display: "flex",
    gap: "1.5rem",
    fontSize: "1rem",
    fontWeight: 700,
    marginLeft: "14rem"
  },

  navItem: {
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "2px",
    color: "#444",
  },

  actions: {
    display: "flex",
    alignItems: "center",
    gap: "8px", // Space between Explore button and Hamburger
  },

  signup: {
    backgroundColor: "#322E31",
    color: "#fff",
    border: "none",
    padding: "6px 16px",
    borderRadius: "8px",
    fontSize: "14px",
    cursor: "pointer",
    fontFamily: "DelightMed",
    whiteSpace: "nowrap",
  },

  signupMobile: {
    backgroundColor: "#322E31",
    color: "#fff",
    border: "none",
    padding: "5px 12px",
    borderRadius: "8px",
    fontSize: "11px", // Slightly smaller for mobile layout
    fontWeight: "bold",
    cursor: "pointer",
    fontFamily: "DelightMed",
    whiteSpace: "nowrap",
  },

  hamburger: {
    background: "transparent",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    padding: "0 4px",
    color:"#000"
  },

  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(0,0,0,0.25)",
    backdropFilter: "blur(2px)",
    zIndex: 999,
  },

  sidebar: {
    position: "fixed",
    top: 0,
    right: 0,
    width: "15rem",
    height: "100vh",
    background: "rgba(255, 255, 255, 0.85)",
    backdropFilter: "blur(16px) saturate(180%)",
    borderLeft: "1px solid rgba(255,255,255,0.3)",
    boxShadow: "-10px 0 30px rgba(0,0,0,0.1)",
    zIndex: 1000,
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    fontFamily: "DelightMed",
  },

  sidebarItem: {
    fontSize: "1.3rem",
    fontWeight: 500,
    cursor: "pointer",
    color: "#333",
  },

  close: {
    alignSelf: "flex-end",
    background: "transparent",
    border: "none",
    fontSize: "22px",
    cursor: "pointer",
    marginBottom: "10px",
  },
};